import { AccordionItemBase } from './accordionItemBase';
import { ConvoMessageItemType } from '@/store/enums/convoMessageItemType.enum.ts';

export class ItemsGroup extends AccordionItemBase {
    constructor(items = []) {
        super(items);
        this.type = ConvoMessageItemType.ItemsGroup;
    }
}
